import { useLocation, useNavigate } from 'react-router-dom';

import { IconButton, RouteProps } from 'components/Blocks';
import { ArrowLeftIcon } from 'components/Blocks/Icons';

import { AppRoute } from 'routes';
import { IsUndefined } from 'types';

type GoBackButtonProps<To extends AppRoute | undefined> = (IsUndefined<To> extends true
  ? { to?: never }
  : Extract<RouteProps, { to: To }>) & {
  className?: string;
};

export function GoBackButton<To extends AppRoute | undefined>(
  props: GoBackButtonProps<To>,
): JSX.Element {
  const navigate = useNavigate();
  const { key } = useLocation();

  const hasBackInHistory = key !== 'default';

  const btnProps = props.to
    ? props
    : // eslint-disable-next-line @typescript-eslint/no-explicit-any
      { onClick: () => navigate((hasBackInHistory ? -1 : '/') as any) };

  return (
    <IconButton size="fit" className={props.className} {...btnProps}>
      <ArrowLeftIcon size={20} />
    </IconButton>
  );
}
